class BlockProductsSlider {
	constructor() {
		const blocks = document.querySelectorAll(".block-story-products, .block-products-slider");
		blocks.forEach(block => {
			const swiper = block.querySelector(".swiper");
			if (!swiper.querySelector(".swiper-slide")) {
				return;
			}
			const prev = block.querySelector(".swiper-prev");
			const next = block.querySelector(".swiper-next");
			new Swiper(swiper, {
				loop: true,
				slidesPerView: "auto",
				spaceBetween: window.innerWidth > 767 ? 70 : 40,
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
			});
		});

	}
}
